import { RouteAction, RouteActionKind } from "../Reducer";
import { RouteState } from "../api/edits/editRoute.responses";
import useEditRouteService from "../api/edits/editRoute.service";
import { useSaveRouteData } from "./useSaveRouteData";
import { toast } from "sonner";

export function useSaveRoute(
  routeState: RouteState,
  routeDispatch: React.Dispatch<RouteAction>,
  setCurrentLanguage: React.Dispatch<React.SetStateAction<string>>,
  setSelected: React.Dispatch<React.SetStateAction<string>>
) {
  const { getRouteState } = useEditRouteService();
  const { saveRouteData } = useSaveRouteData();

  const handleLoadRoute = async (routeId: string) => {
    try {
      const routeStateData = (await getRouteState(routeId)).data;

      console.log(JSON.stringify(routeStateData, null, 2));

      routeDispatch({
        type: RouteActionKind.LOAD_ROUTE,
        payload: routeStateData,
      });
      setSelected("rprop");
    } catch (err: any) {
      if (err.response) {
        alert(err.response.data);
      } else {
        console.log(`Error: ${err.message}`);
      }
    }
  };

  const handleSaveRoute = () => {
    toast.promise(
      async () => {
        await saveRouteData(routeState);
        await handleLoadRoute(routeState.id);
      },
      {
        loading: "Saving route...",
        success: "Route saved successfully",
        error: (err: any) =>
          `Save failed: ${err?.response?.data?.message ?? err?.message ?? "Unknown error"}`,
      }
    );
  };

  return { handleSaveRoute };
}
